//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Annotations.js";
import "../no/Drawings.js";
import "../no/Part.js";
let d=[[],[[[],"VersionUpAllDraftingObjects",{},0,1],[["drafting_objects"],"VersionUpSelectedDraftingObjects",{},1,1],[[],"CreateImportSymbolBuilder",{R_:{builder:"Annotations.ImportSymbolBuilder"}},0,0],[[],"CreateMarkAsTemplateBuilder",{R_:{builder:"Drawings.MarkAsTemplateBuilder"}},0,0],[[],"CreateSheetZoneReferenceBuilder",{R_:{builder:"Drawings.SheetZoneReferenceBuilder"}},0,0],[[],"CreateImportAutocadBlockBuilder",{R_:{builder:"Annotations.ImportAutocadBlockBuilder"}},0,0],[[],"GetTemplateInstantiationIsComplete",{R_:{templateInstantiationStatus:''}},0,0],[["templateInstantiationStatus"],"SetTemplateInstantiationIsComplete",{},1,0],[["object"],"AddCutObject",{},1,0],[[],"RestoreUnpastedObjects",{},0,0],[["partOfUnpastedObject"],"RestoreUnpastedObjectsOfPart",{},1,0],[["object"],"IsCutObject",{R_:{cut:''}},1,0],[["objects"],"CreateDrawingsPropertiesBuilder",{R_:{builder:"Drawings.DrawingsPropertiesBuilder"}},1,0],[[],"EnterDraftingApplication",{},0,0],[[],"ExitDraftingApplication",{},0,0],[["set_to_drawing_layout"],"SetDrawingLayout",{},1,0],[[],"RenewObjects",{R_:{renewStatus:''}},0,0]],[["SectionLines","Drawings.SectionLineCollection",0],["AutomationManager","Drafting.AutomationManager",0],["BordersAndZonesObjects","Drawings.BordersAndZonesCollection",0]]];
SPLM.DraftingManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DraftingManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;